
export default {
  compareNumbers(a, b) {
    if (a === b) return 0;
    if (Number.isNaN(a)) return -1;
    if (Number.isNaN(b)) return 1;
    return (a > b ? 1 : -1);
  },
  compareDates(a, b) {
    const aValue = a.getTime();
    const bValue = b.getTime();
    if (aValue === bValue) return 0;
    return (aValue > bValue ? 1 : -1);
  },
  compareLiteral(a, b) {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  },
};
